import { usePendingMarketingConsent } from '@features/auth'

/**
 * Досылает согласие на рекламу, поставленное галочкой при регистрации.
 *
 * Отдельный плагин, а не вызов внутри формы: между галочкой и появлением токена
 * стоит подтверждение телефона через Telegram или MAX, во время которого форма
 * уже размонтирована. Watcher переживает эту паузу и отправляет решение, когда
 * профиль загрузится.
 */
export default defineNuxtPlugin(() => {
  usePendingMarketingConsent()
})
